import { useEffect, useRef, useState } from "react";

/**
 * 
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const CustomHorizontalInfiniteScrollApp = (scrollStep = 450) => {
    const containerRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);
    const [canScroll, setCanScroll] = useState(false);

    const updateScrollState = () => {
        const container = containerRef.current;
        if (!container) return;
        setIsAtStart(container.scrollLeft <= 10);
        setCanScroll(container.scrollWidth > container.clientWidth);
    };

    const scrollLeft = () => {
        containerRef.current?.scrollBy({ left: -scrollStep, behavior: "smooth" });
    };

    const scrollRight = () => {
        const container = containerRef.current;
        if (!container) return;

        const { scrollLeft: current, scrollWidth, clientWidth } = container;
        const nearEnd = current + clientWidth >= scrollWidth - 10;

        if (nearEnd) {
            container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
            container.scrollBy({ left: scrollStep, behavior: "smooth" });
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener("scroll", updateScrollState);
            updateScrollState();
        }

        const handleResize = () => updateScrollState();
        window.addEventListener("resize", handleResize);

        return () => {
            container?.removeEventListener("scroll", updateScrollState);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return {
        containerRef,
        isAtStart,
        canScroll,
        scrollLeft,
        scrollRight
    };
};

export default CustomHorizontalInfiniteScrollApp;
